// GTM
import { useEffect } from 'react';
import { useConsent } from '../ConsentContext';

export const StackAdapt = () => {
  const { consent } = useConsent();

  function deleteSaCookies() {
    Object.keys(
      document.cookie.split('; ').reduce(
        (acc, cookie) => {
          const [name] = cookie.split('=');
          if (name.startsWith('sa-')) {
            document.cookie = `${name}=; Max-Age=0; path=/; domain=${window.location.hostname};`;
          }
          return acc;
        },
        {} as Record<string, string>,
      ),
    );
  }

  useEffect(() => {
    if (consent === 'decline') {
      const script = document.getElementById('stack-tag');
      deleteSaCookies();
      if (script) {
        script.remove();
      }
    } else {
      if (consent === 'accept' || document.cookie.indexOf(`cookies_accepted=`) === -1) {
        const script = document.createElement('script');
        script.id = 'stack-tag';
        script.innerHTML = `!function(s,a,e,v,n,t,z){if(s.saq)return;n=s.saq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!s._saq)s._saq=n;n.push=n;n.loaded=!0;n.version='1.0';n.queue=[];t=a.createElement(e);t.async=!0;t.src=v;z=a.getElementsByTagName(e)[0];z.parentNode.insertBefore(t,z)}(window,document,'script','https://tags.srv.stackadapt.com/events.js');saq('ts [tags.srv.stackadapt.com]', '${process.env.REACT_APP_STACK}');`;
        document.head.appendChild(script);
      }
    }
  }, [consent]);

  return null;
};
